import { removeNode, closest } from '@utils/domUtils';
import { post } from '@utils/request';

/* global ACTION_ROUTES */

export default class NotificationItem {
  static selectorString() {
    return '.NotificationItem';
  }

  render(node, props) {
    this.list = closest(this.node, '.NotificationList');
    node.querySelector('.close-icon').addEventListener('click', this.markAsRead.bind(this));
  }

  markAsRead() {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;

    post({
      url: ACTION_ROUTES.MARK_NOTIFICATION_AS_READ,
      data: {
        notificationId: this.props.id,
      },
      success: data => {
        this.isSubmitting = false;
        removeNode(this.node);
        this.list.component.refresh();

        const notificationsCount = [...this.list.querySelectorAll('.NotificationItem')].length;

        [...document.querySelectorAll('.unread-notifications-count-label')].forEach(element => {
          element.innerHTML = notificationsCount;
        });

        [...document.querySelectorAll(`.NotificationItem[data-id="${this.props.id}"]`)].forEach(
          element => {
            const otherList = closest(element, '.NotificationList');
            removeNode(element);
            otherList.component.refresh();
          },
        );
      },
      error: data => {
        this.isSubmitting = false;
      },
    });
  }
}
